const MOCK_IMAGES = Array.from({ length: 16 }, (_, i) => ({
  id: `mock-image-${i + 1}`,
  image_url: `https://picsum.photos/seed/${i + 10}/512/512`,
  text_prompts: ['a beautiful mountain landscape at sunset', 'cyberpunk city at night', 'watercolor portrait of a woman', 'abstract digital art with neon colors'][i % 4],
  negative_prompts: 'blurry, bad quality, low resolution',
  seed: 42000 + i,
  sampler: 'EulerDiscreteScheduler',
  steps: 20,
  model_id: 'stable-diffusion-v1-6',
  style_preset: ['photographic', 'anime', 'digital-art', 'cinematic'][i % 4],
  cfg_scale: 7,
  height: 512,
  width: 512,
  author_avatar: `https://i.pravatar.cc/40?img=${i + 1}`,
  user_id: `mock-user-${(i % 3) + 1}`,
  author_name: [`Alice`, `Bob`, `Charlie`][i % 3],
  generate_type: i % 5 === 0 ? 'jinshu' : 'text2image',
  jinshu: i % 5 === 0 ? { prompt: 'golden metallic texture', text_content: '创意' } : undefined,
  liked: i % 3 === 0,
  like_count: Math.floor(Math.random() * 100),
  is_public: true,
  created_at: new Date(Date.now() - i * 3_600_000).toISOString(),
  lora_model: '',
  lora_strength: '',
}))

const MOCK_USER = {
  id: 'mock-user-1',
  nickname: 'Mock User',
  avatar: 'https://i.pravatar.cc/80?img=1',
  email: 'mock@example.com',
  vip_level: 101,
  credits: 500,
  created_at: '2024-01-01T00:00:00Z',
}

const MOCK_PRICE = [
  {
    id: 10,
    name: '首充会员（月度）',
    price: 9.9,
    origin_price: 9.9,
    credit: 100,
    desc: '满足基本对话绘画需求',
    features: ['支持AI对话', '支持文生图、图生图', '文生图可同时创作4个作品', '支持高清修复'],
  },
  {
    id: 11,
    name: '体验会员（月度）',
    price: 45,
    origin_price: 45,
    credit: 200,
    desc: '满足基本对话绘画需求',
    features: ['支持AI对话', '支持文生图、图生图', '文生图可同时创作4个作品', '支持高清修复'],
  },
  {
    id: 100,
    name: '标准会员',
    price: 45,
    origin_price: 45,
    credit: 200,
    desc: '满足基本对话绘画需求',
    features: ['支持AI对话', '支持文生图、图生图', '文生图可同时创作4个作品', '支持高清修复'],
  },
  {
    id: 101,
    name: '高级会员',
    price: 85,
    origin_price: 85,
    credit: 500,
    desc: '多数人的选择',
    features: ['支持AI对话', '支持GPT4', '支持文生图、图生图', '文生图可同时创作4个作品', '支持高清修复', '支持妙笔', '支持Stable Diffusion 3'],
  },
  {
    id: 102,
    name: '超级会员',
    price: 160,
    origin_price: 160,
    credit: 1000,
    desc: '更多特色功能开放使用',
    features: ['支持AI对话', '支持GPT4', '支持文生图、图生图', '文生图可同时创作4个作品', '支持高清修复', '支持妙笔', '支持Stable Diffusion 3'],
  },
  { id: 200, name: '季度标准会员', price: 121.5, origin_price: 135, credit: 600, desc: '满足基本对话绘画需求', features: ['支持AI对话', '支持文生图、图生图'] },
  { id: 201, name: '季度高级会员', price: 229.5, origin_price: 255, credit: 1500, desc: '多数人的选择', features: ['支持AI对话', '支持GPT4', '支持文生图、图生图', '支持妙笔'] },
  {
    id: 202,
    name: '季度超级会员',
    price: 432,
    origin_price: 480,
    credit: 3000,
    desc: '更多特色功能开放使用',
    features: ['支持AI对话', '支持GPT4', '支持文生图、图生图', '支持妙笔'],
  },
  { id: 300, name: '年度标准会员', price: 432, origin_price: 540, credit: 2400, desc: '满足基本对话绘画需求', features: ['支持AI对话', '支持文生图、图生图'] },
  { id: 301, name: '年度高级会员', price: 816, origin_price: 1020, credit: 6000, desc: '多数人的选择', features: ['支持AI对话', '支持GPT4', '支持文生图、图生图', '支持妙笔'] },
  {
    id: 302,
    name: '年度超级会员',
    price: 1536,
    origin_price: 1920,
    credit: 12000,
    desc: '更多特色功能开放使用',
    features: ['支持AI对话', '支持GPT4', '支持文生图、图生图', '支持妙笔'],
  },
]

const MOCK_ENGINES = [
  { id: 'stable-diffusion-v1-6', name: 'Stable Diffusion v1.6', description: 'Standard quality generation' },
  { id: 'stable-diffusion-xl-1024-v1-0', name: 'Stable Diffusion XL v1.0', description: 'High quality 1024px generation' },
]

const MOCK_MODELS = [
  { model_id: 'realistic-vision-v5', name: 'Realistic Vision V5', preview_url: 'https://picsum.photos/seed/m1/100/100', type: 'checkpoint' },
  { model_id: 'dreamshaper-8', name: 'DreamShaper 8', preview_url: 'https://picsum.photos/seed/m2/100/100', type: 'checkpoint' },
  { model_id: 'anything-v5', name: 'Anything V5', preview_url: 'https://picsum.photos/seed/m3/100/100', type: 'checkpoint' },
]

const MOCK_LORAS = [
  { lora_model_id: 'lora-detail-tweaker', name: 'Detail Tweaker', preview_url: 'https://picsum.photos/seed/l1/100/100' },
  { lora_model_id: 'lora-add-detail', name: 'Add Detail', preview_url: 'https://picsum.photos/seed/l2/100/100' },
]

const MOCK_CATEGORIES = [
  { id: 1, name: '写实风格', style_preset: 'photographic' },
  { id: 2, name: '动画风格', style_preset: 'anime' },
  { id: 3, name: '数字艺术', style_preset: 'digital-art' },
  { id: 4, name: '电影风格', style_preset: 'cinematic' },
]

const MOCK_CREDITS = Array.from({ length: 10 }, (_, i) => ({
  id: `credit-${i + 1}`,
  amount: [100, -10, -5, 200, -20][i % 5],
  type: i % 2 === 0 ? 'recharge' : 'consume',
  desc: i % 2 === 0 ? '充值积分' : '生成图片消耗',
  created_at: new Date(Date.now() - i * 86_400_000).toISOString(),
}))

const MOCK_ORDERS = Array.from({ length: 5 }, (_, i) => ({
  id: `order-${i + 1}`,
  amount: [9.9, 45, 85, 160, 45][i],
  status: 'paid',
  product_name: ['首充会员', '体验会员', '高级会员', '超级会员', '标准会员'][i],
  created_at: new Date(Date.now() - i * 30 * 86_400_000).toISOString(),
}))

const MOCK_CONVERSATIONS = [
  { conversation_id: 'mock-conv-1', name: 'AI 绘画讨论', created_at: '2024-03-01T10:00:00Z' },
  { conversation_id: 'mock-conv-2', name: '技术咨询', created_at: '2024-03-02T11:00:00Z' },
]

const MOCK_MESSAGES = [
  { id: 'msg-1', role: 'user', content: '你好，帮我生成一张风景图的提示词', created_at: '2024-03-01T10:00:00Z' },
  {
    id: 'msg-2',
    role: 'assistant',
    content: 'A breathtaking mountain landscape at golden hour, dramatic clouds, ultra realistic, 8k, photorealistic',
    created_at: '2024-03-01T10:00:05Z',
  },
]

const MOCK_IMAGE_PRICE = [
  { type: 'text2image', credit_cost: 5, name: '文生图' },
  { type: 'image2image', credit_cost: 8, name: '图生图' },
  { type: 'upscale', credit_cost: 10, name: '高清修复' },
  { type: 'mj_create', credit_cost: 15, name: 'Midjourney' },
]

const MOCK_BOTS = [
  {
    id: 'bot-1',
    name: '绘画助手',
    icon_url: 'https://i.pravatar.cc/80?img=10',
    credit: 5,
    description: '帮助你生成更好的图像提示词',
    onboarding_info: { prologue: '你好！我是绘画助手，可以帮你优化图像生成提示词，让作品更出色。' },
  },
  {
    id: 'bot-2',
    name: '创意顾问',
    icon_url: 'https://i.pravatar.cc/80?img=11',
    credit: 8,
    description: '激发你的创意灵感',
    onboarding_info: { prologue: '嗨！我是创意顾问，擅长激发灵感、头脑风暴，让我们一起创作吧！' },
  },
]

const MOCK_CHAT_MODELS = [
  { model: 'gpt-3.5-turbo', name: 'GPT-3.5', description: '快速响应' },
  { model: 'gpt-4', name: 'GPT-4', description: '更强推理', vip_required: true },
]

function createMockStreamResponse(text) {
  const encoder = new TextEncoder()
  const words = text.split(' ')
  const stream = new ReadableStream({
    start(controller) {
      let i = 0
      const tick = () => {
        if (i < words.length) {
          const chunk = `data: ${JSON.stringify({ answer: `${words[i]} `, event: 'message' })}\n\n`
          controller.enqueue(encoder.encode(chunk))
          i += 1
          setTimeout(tick, 40)
        } else {
          controller.enqueue(encoder.encode('data: [DONE]\n\n'))
          controller.close()
        }
      }
      tick()
    },
  })
  return { body: stream, ok: true, status: 200, headers: new Headers() }
}

const STREAM_MOCK_TEXT = '这是一条来自 Mock 模式的 AI 回复。在真实环境下这里会返回后端的流式响应内容。你可以通过设置 NEXT_PUBLIC_MOCK=false 切换到真实接口。'

export function getMockResponse(path) {
  const basePath = path.split('?')[0]

  // Auth
  if (basePath.includes('user/login') || basePath.includes('user/register')) {
    return { code: 200, data: { token: 'mock-token-12345', user: MOCK_USER }, message: 'success' }
  }
  if (basePath.includes('send_verification_code')) {
    return { code: 200, message: '验证码已发送' }
  }

  // User info
  if (basePath.includes('fetch_user_basic_info')) {
    return { code: 200, data: MOCK_USER }
  }
  if (basePath.includes('fetch_user_info')) {
    return { code: 200, data: { ...MOCK_USER, id: 'mock-user-2', nickname: 'Other User' } }
  }
  if (basePath.includes('change_nickname') || basePath.includes('upload_avatar')) {
    return { code: 200, message: 'success' }
  }

  // Invite
  if (basePath.includes('generate_invite_code')) {
    return { code: 200, data: 'MOCK2024' }
  }
  if (basePath.includes('get_invite_info')) {
    return { code: 200, invite_details: [], invitee_count: 3 }
  }

  // Pricing & orders
  if (basePath.includes('get_shop_price')) {
    const priceMap = {}
    MOCK_PRICE.forEach((p) => {
      priceMap[p.id] = p
    })
    return { code: 200, data: priceMap }
  }
  if (basePath.includes('get_user_orders')) {
    return { code: 200, data: { orders: MOCK_ORDERS, total: MOCK_ORDERS.length } }
  }
  if (basePath.includes('mzf_pay')) {
    return { code: 200, data: '/' }
  }

  // Credits
  if (basePath.includes('get_credit_details')) {
    return { code: 200, data: { data: MOCK_CREDITS, total: MOCK_CREDITS.length } }
  }

  // Images
  if (basePath.includes('get_image_price')) {
    return { code: 200, data: MOCK_IMAGE_PRICE }
  }
  if (basePath.includes('fetch_image_info')) {
    return { code: 200, data: MOCK_IMAGES[0] }
  }
  if (basePath.includes('fetch_show_images') || basePath.includes('fetch_selection_images') || basePath.includes('search_images_by_style_preset')) {
    return { code: 200, data: MOCK_IMAGES }
  }
  if (basePath.includes('fetch_user_space_images') || basePath.includes('fetch_created_images')) {
    return { code: 200, data: MOCK_IMAGES.slice(0, 8) }
  }
  if (basePath.includes('fetch_liked_images')) {
    return { code: 200, data: MOCK_IMAGES.filter((_, i) => i % 3 === 0) }
  }
  if (basePath.includes('fetch_user_today_images')) {
    return { code: 200, data: MOCK_IMAGES.slice(0, 4) }
  }
  if (basePath.includes('search_images')) {
    return { code: 200, data: MOCK_IMAGES.slice(0, 6) }
  }
  if (basePath.includes('fetch_random_tip')) {
    return { code: 200, data: 'a beautiful sunset over the ocean, golden hour, ultra detailed' }
  }
  if (
    basePath.includes('text-to-image') ||
    basePath.includes('image-to-image') ||
    basePath.includes('mj_create') ||
    basePath.includes('sd_three') ||
    basePath.includes('jinshu_create') ||
    basePath.includes('fast_upscale')
  ) {
    return { code: 200, data: { task_id: 'mock-task-001', job_id: 'mock-job-001' } }
  }
  if (basePath.includes('v1/tasks/') || basePath.includes('fetch_mj_result') || basePath.includes('steam_jinshu_result')) {
    return { code: 200, data: { status: 'success', image_url: MOCK_IMAGES[0].image_url, images: [MOCK_IMAGES[0]] } }
  }
  if (
    basePath.includes('add_like_image') ||
    basePath.includes('dislike_image') ||
    basePath.includes('set_image_public') ||
    basePath.includes('set_image_private') ||
    basePath.includes('delete_image') ||
    basePath.includes('deactivate_image') ||
    basePath.includes('add_selection_image') ||
    basePath.includes('remove_selection_image')
  ) {
    return { code: 200, message: 'success' }
  }
  if (basePath.includes('fetch_all_images')) {
    return { code: 200, data: { images: MOCK_IMAGES, total: MOCK_IMAGES.length } }
  }

  // Models
  if (basePath.includes('engines/list')) {
    return MOCK_ENGINES
  }
  if (basePath.includes('fetch_models_list')) {
    return { code: 200, data: MOCK_MODELS }
  }
  if (basePath.includes('fetch_lora_list')) {
    return { code: 200, data: MOCK_LORAS }
  }
  if (basePath.includes('fetch_category_list')) {
    return { code: 200, data: MOCK_CATEGORIES }
  }

  // Prompt
  if (basePath.includes('generate_random_prompt')) {
    return { code: 200, data: ['masterpiece, best quality, beautiful landscape, 8k', 'cyberpunk city, neon lights, rain, ultra detailed'] }
  }

  // Chat
  if (basePath.includes('get_model_info')) {
    return MOCK_CHAT_MODELS
  }
  if (basePath.includes('get_all_bot')) {
    return { code: 200, data: MOCK_BOTS }
  }
  if (basePath.includes('get_conversation')) {
    return { code: 200, data: MOCK_CONVERSATIONS }
  }
  if (basePath.includes('create_conversation')) {
    return { code: 200, data: { conversation_id: `mock-conv-${Date.now()}`, name: '新对话' } }
  }
  if (basePath.includes('get_messages')) {
    return { code: 200, data: { messages: MOCK_MESSAGES, followup_message: ['帮我优化这个提示词', '给我更多例子'] } }
  }
  if (basePath.includes('auto_generate_conversation_name')) {
    return { code: 200, data: 'Mock 对话' }
  }
  if (basePath.includes('rename_conversation') || basePath.includes('delete_conversation') || basePath.includes('update_messages')) {
    return { code: 200, message: 'success' }
  }

  return { code: 200, data: null, message: `mock: no data for ${basePath}` }
}

export function getMockStreamResponse() {
  return createMockStreamResponse(STREAM_MOCK_TEXT)
}
